import { itemVariantQuantities } from './variant-quantities.mjs';

export function parseCartQuantity(raw) {
  const text = String(raw).trim().replace(',', '.');
  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)) return null;
  const value = Number(text);
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function stepCartQuantity(value, delta) {
  const current = Number(value), next = current + delta;
  // Keep the existing +/- 1 steps except when minus would remove the row.
  return delta < 0 && next <= 0 ? Math.min(current, 0.5) : next;
}

export function withCartQuantity(item, qty) {
  if (!Number.isFinite(qty) || qty <= 0) return item;
  const variants = itemVariantQuantities(item);
  // Multiple variants keep the existing per-variant allocation controls.
  if (variants.length > 1) return item;
  return variants.length
    ? { ...item, qty, variant: null, variant_quantities: [{ ...variants[0], qty }] }
    : { ...item, qty };
}
